import React from 'react'
import clsx from 'clsx'

import { IconBulletActive, IconBulletInActive } from 'components/Icons'
import { statusFilter } from 'helpers/common'

export interface Props {
  /**
   * Is check status sku active or none-active?
   */
  isActive?: boolean
  /**
   * Show label text?
   */
  isShowLabel?: boolean

  className?: string

  variants?: 'xs' | 'sm' | 'md' | 'lg'

  positionLabel?: 'left' | 'right'
}

function BulletLabel(props: Props): JSX.Element {
  const base = 'con-bullet'
  const {
    isActive,
    isShowLabel,
    className,
    variants = 'xs',
    positionLabel = 'right',
  } = props

  const icon = isActive ? (
    <IconBulletActive variants={variants} data-testid='icon-active' />
  ) : (
    <IconBulletInActive variants={variants} data-testid='icon-inactive' />
  )
  const label = statusFilter(Boolean(isActive))

  const renderLabelText = () => {
    return (
      <span
        className={clsx(`${base}__label--${positionLabel}`, className)}
        data-testid={`${base}__label`}
      >
        {label}
      </span>
    )
  }

  const renderBullet = (position: string) => {
    switch (position) {
      case 'right':
        return (
          <div className={`${base}__position--${position}`}>
            <div className={`${base}__icon`} data-testid={`${base}__icon`}>
              {icon}
            </div>
            {isShowLabel && renderLabelText()}
          </div>
        )

      case 'left':
        return (
          <div className={`${base}__position--${position}`}>
            {isShowLabel && renderLabelText()}
            <div className={`${base}__icon`} data-testid={`${base}__icon`}>
              {icon}
            </div>
          </div>
        )
    }
  }

  return <div className={base}>{renderBullet(positionLabel)}</div>
}

export default BulletLabel
